'use client';
import clsx from 'clsx';
import Image from 'next/image';

import type { GenericImage } from '@/models/generic.model';

const logos: GenericImage[] = [
  { src: '/logos/cbs_logo.png', alt: 'cbs_logo', width: 80, height: 24, opacity: 0.4 },
  { src: '/logos/inc_logo.png', alt: 'inc_logo', width: 70, height: 24, opacity: 0.4 },
  { src: '/logos/forbes-logo.png', alt: 'forbes_logo', width: 93, height: 24 },
  { src: '/logos/sbj-logo.png', alt: 'sbj_logo', width: 115, height: 24, opacity: 0.4 },
];

interface SwabKitProductDetailsTransformationalProps {
  className?: string;
}

export const SwabKitProductDetailsTransformational: React.FC<
  SwabKitProductDetailsTransformationalProps
> = ({ className }) => {
  return (
    <div className={clsx('border border-1 border-badge-gray rounded-[8px] p-4 md:p-6', className)}>
      <div
        className={clsx(
          'text-center font-light mb-4 md:mb-8',
          'text-[15px] leading-[22.5px] tracking-[-0.45px]',
          'md:text-lg md:leading-[27px] md:tracking-[-0.54px]'
        )}
      >
        “Transformational approach that revolutionizes personalized fitness by bringing together
        multiple fitness and stress management products into one”
      </div>
      <div className="flex flex-wrap md:justify-between justify-center items-center">
        {logos.map((logo, index) => (
          <Image
            key={index}
            src={logo.src}
            alt={logo.alt}
            width={logo.width}
            height={logo.height}
            style={{ filter: 'grayscale(100%)' }}
            className={clsx(
              {
                'opacity-40 md:block hidden': logo.opacity,
              },
              'h-[16px] w-[62px]',
              'md:h-[24px] md:w-auto'
            )}
          />
        ))}
      </div>
    </div>
  );
};
